import { FC } from 'react';
import intl from 'react-intl-universal';
import {
  UsersPicker,
  Button,
  tailwindOverride,
} from '@getsynapse/design-system';
import { useSearchMembers } from '../../../../../../hooks/useSearchMembers/useSearchMembers';
import { UserAvatars } from 'utils/customTypes';
import { AddTeamMembersHandler } from 'types/store/learningTeam';
import UnsavedChangesPrompt from 'Organisms/UnsavedChangesPrompt/UnsavedChangesPrompt';

interface SearchMembersProps {
  onCancel: () => void;
  onAddUsers: AddTeamMembersHandler;
}

const SearchMembers: FC<SearchMembersProps> = ({ onCancel, onAddUsers }) => {
  const {
    filteredUsers,
    handleSearchChange,
    handleSelectUsers,
    selectedUsers,
    canAddUsers,
    handleAddUsers,
    isUpdatingLDTeamMembers,
  } = useSearchMembers(onAddUsers);
  return (
    <div className='flex gap-x-4'>
      <div className='min-w-0 flex-1 max-w-lg'>
        <UsersPicker
          triggerText={intl.get(
            'ORG_SETTINGS_PAGE.LEARNING_TEAM_DETAILS_PAGE.SEARCH_MEMBERS_PLACEHOLDER'
          )}
          usersList={filteredUsers}
          onFilterChange={handleSearchChange}
          selectedUsersList={selectedUsers as UserAvatars[]}
          onChange={handleSelectUsers}
          triggerClassName={tailwindOverride('max-w-lg py-1.5', {
            'py-px': selectedUsers.length > 0,
          })}
          popperClassName='max-w-lg'
          multiple
          deactivatedUserText={intl.get(
            'ORG_SETTINGS_PAGE.LEARNING_TEAM_DETAILS_PAGE.TEAM_MANAGER'
          )}
        />
      </div>
      <div className='flex shrink-0 gap-x-2'>
        <Button
          disabled={!canAddUsers}
          onClick={handleAddUsers}
          loading={isUpdatingLDTeamMembers}
          className='h-10'
        >
          {intl.get('ADD')}
        </Button>
        <Button variant='tertiary' onClick={onCancel} className='h-10'>
          {intl.get('CANCEL')}
        </Button>
      </div>
      <UnsavedChangesPrompt hasChanges={canAddUsers} />
    </div>
  );
};

export default SearchMembers;
